import React from 'react'

export const NotFound = () => {
    return (
        <section className="not-found-box">
            <h2 className="not-found-title">Wait.....you're not supposed to be here!</h2>
        </section>
    )
}